import React, { useState } from 'react';
import { Leaf, Sprout, Wheat, ChevronDown } from 'lucide-react';
import SectionHeader from '../components/SectionHeader';

interface DishProps {
  name: string;
  description: string;
  price: string;
  dietary: string[];
  category: string;
}

const MenuPage: React.FC = () => {
  const [openAccordion, setOpenAccordion] = useState<string>('main');
  const menuCategories = {
    breakfast: [
      {
        name: 'Full Breakfast',
        description: 'Link Sausage, Square Sausage, Bacon, Stornoway Black Pudding, Haggis, Egg, Beans, Tattie Scone, Tomatoes, Mushrooms. Served with Toast',
        price: '£12.95 Sit In / £11.95 Takeaway',
        dietary: [],
        category: 'Breakfast'
      },
      {
        name: 'Vegetarian Breakfast',
        description: 'Vegetarian Sausage, Hash Brown, Tattie Scone, Mushrooms, Tomatoes, Beans, Egg. Served with Toast',
        price: '£9.95 Sit In / £8.95 Takeaway',
        dietary: ['v'],
        category: 'Breakfast'
      },
      {
        name: 'Tattie Tower',
        description: 'Tattie Scone, Link Sausage, Bacon, Egg. Served with Peppercorn sauce',
        price: '£10.95 Sit In / £9.95 Takeaway',
        dietary: [],
        category: 'Breakfast'
      },
      {
        name: 'Breakfast Roll',
        description: 'Link Sausage, Square Sausage, Bacon, Haggis, Scrambled Egg',
        price: '£9.45',
        dietary: [],
        category: 'Breakfast'
      },
      {
        name: 'Roll & Hot Drink',
        description: '',
        price: '£3.45',
        dietary: [],
        category: 'Breakfast'
      },
      {
        name: 'Scrambled Egg on Toast',
        description: '',
        price: '£4.95',
        dietary: ['v'],
        category: 'Breakfast'
      },
      {
        name: 'Poached Egg on Toast',
        description: '',
        price: '£4.95',
        dietary: ['v'],
        category: 'Breakfast'
      }
    ],
    starters: [
      {
        name: 'Soup of The Day',
        description: '',
        price: '£4.95',
        dietary: [],
        category: 'Starters'
      },
      {
        name: 'Bruschetta',
        description: '3 Slices of Garlic Bread, Topped with Authentic Tomato & Basil, drizzled with Balsamic Glaze',
        price: '£5.95',
        dietary: ['v'],
        category: 'Starters'
      },
      {
        name: 'Black Pudding Pakora',
        description: 'A Scottish-Indian Fusion of Stornoway Black Pudding and Homemade Pakora, served with Mini Poppadom\'s and a Spicy Onion & Pakora Dip',
        price: '£6.95',
        dietary: [],
        category: 'Starters'
      },
      {
        name: 'Blaggis Fritter',
        description: 'A Combination of Black Pudding & Haggis Fritters, served with Pepper Sauce',
        price: '£5.95',
        dietary: [],
        category: 'Starters'
      },
      {
        name: 'Breaded Mozzarella Sticks',
        description: 'With your Choice of Dip (Garlic Mayo or Thai Sweet Chilli or BBQ)',
        price: '£6.95',
        dietary: ['v'],
        category: 'Starters'
      },
      {
        name: 'Chicken Goujons',
        description: 'Strips of Chicken coated in Breadcrumbs. With your Choice of Dip (Garlic Mayo, Thai Sweet Chilli or BBQ)',
        price: '£6.95',
        dietary: [],
        category: 'Starters'
      },
      {
        name: 'Prawn Cocktail',
        description: 'Fresh Prawns, in a Seafood Marie-Rose sauce, served with Crunchy Lettuce',
        price: '£6.95',
        dietary: [],
        category: 'Starters'
      },
      {
        name: 'Nachos',
        description: 'Tortilla Chips, Covered in Scottish Mature Cheddar Cheese. Salsa, Jalepenos & Sour Cream. Choice to Add Cajun Chicken (£3)',
        price: '£5.95',
        dietary: ['v'],
        category: 'Starters'
      },
      {
        name: 'Mac & Cheese Bites',
        description: 'Mac \'n\' Cheese bites, Coated in Breadcrumbs. With your Choice of Dip (Garlic Mayo, Thai Sweet Chilli or BBQ)',
        price: '£5.95',
        dietary: ['v', 'gf'],
        category: 'Starters'
      }
    ],
    mains: [
      {
        name: 'Bonnie Prince Charlie',
        description: '5oz. Sirloin Steak & Haggis. Topped with Creamy Drambuie Whisky Sauce',
        price: '£18.95',
        dietary: [],
        category: 'Mains'
      },
      {
        name: 'Homemade Steak Pie',
        description: 'Signature Creamery Steak Pie. Tender chunks of slow cooked beef. Served with fresh vegetables',
        price: '£15.95',
        dietary: [],
        category: 'Mains'
      },
      {
        name: 'Haddock & Chips',
        description: 'Breaded or Battered Angel Cut Haddock. Served with Salad or Peas',
        price: '£15.95',
        dietary: [],
        category: 'Mains'
      },
      {
        name: 'Scampi',
        description: 'Breaded Wholetail Scampi. Served with chips and Salad. With option of Tartar Sauce',
        price: '£16.95',
        dietary: [],
        category: 'Mains'
      },
      {
        name: 'Cajun Chicken',
        description: 'Chicken breast marinated in Cajun spices. With option of our chefs own Cajun sauce or garlic butter. Salad or Veg',
        price: '£16.95',
        dietary: [],
        category: 'Mains'
      },
      {
        name: 'Philly Cheese Wrap',
        description: 'Pan-fried minute steak, onions & peppers, with melted Philly cheese. Served in a toasted tortilla wrap. With salad & chips',
        price: '£14.95',
        dietary: [],
        category: 'Mains'
      },
      {
        name: 'Macaroni Cheese',
        description: 'Macaroni Pasta in our own cheese sauce. Served with Chips and Garlic Bread',
        price: '£12.95',
        dietary: ['v'],
        category: 'Mains'
      }
    ],
    burgers: [
      {
        name: 'Classic Cheeseburger',
        description: 'All Served with Chips, Onion rings, Salad & Coleslaw. Option to upgrade to loaded fries (£3)',
        price: '£8.95 / £11.95',
        dietary: [],
        category: 'Burgers'
      },
      {
        name: 'Chicken Burger',
        description: 'Battered chicken breast fillet. With Lettuce & Mayo. Served with onion rings. All Served with Chips, Onion rings, Salad & Coleslaw. Option to upgrade to loaded fries (£3)',
        price: '£8.95 / £11.95',
        dietary: [],
        category: 'Burgers'
      },
      {
        name: 'Balmoral Burger',
        description: '100% Steak Burgers. Haggis. Served with Onion rings. With the Chef\'s own peppercorn sauce. All Served with Chips, Onion rings, Salad & Coleslaw. Option to upgrade to loaded fries (£3)',
        price: '£10.95 / £13.95',
        dietary: [],
        category: 'Burgers'
      },
      {
        name: 'Black Heart Burger',
        description: '100% Steak Burgers. Stornoway Black Pudding. Chilli Honey Sauce. All Served with Chips, Onion rings, Salad & Coleslaw. Option to upgrade to loaded fries (£3)',
        price: '£10.95 / £13.95',
        dietary: [],
        category: 'Burgers'
      },
      {
        name: 'Mexican Burger',
        description: '100% Steak Burgers. Salsa, Jalepenos & Mozzarella. All Served with Chips, Onion rings, Salad & Coleslaw. Option to upgrade to loaded fries (£3)',
        price: '£10.95 / £13.95',
        dietary: [],
        category: 'Burgers'
      },
      {
        name: 'Veggie Burger',
        description: 'Breaded veg quarter pounder. Lettuce. With veg mayo or sweet chilli. All Served with Chips, Onion rings, Salad & Coleslaw. Option to upgrade to loaded fries (£3)',
        price: '£8.95 / £11.95',
        dietary: ['v'],
        category: 'Burgers'
      },
      {
        name: 'Cajun Chicken Burger',
        description: 'Chicken breast marinated in Cajun spices. With our chef\'s own Cajun Sauce. All Served with Chips, Onion rings, Salad & Coleslaw. Option to upgrade to loaded fries (£3)',
        price: '£11.95',
        dietary: [],
        category: 'Burgers'
      }
    ],
    loadedFries: [
      {
        name: 'Dirty Fries',
        description: 'BBQ Pulled Pork and Mozzarella',
        price: '£6.95',
        dietary: [],
        category: 'Loaded Fries'
      },
      {
        name: 'Spicy Buffalo Fries',
        description: '',
        price: '£6.95',
        dietary: [],
        category: 'Loaded Fries'
      },
      {
        name: 'Cajun Loaded Fries',
        description: '',
        price: '£6.95',
        dietary: [],
        category: 'Loaded Fries'
      },
      {
        name: 'Hunters Chicken Loaded Fries',
        description: '',
        price: '£6.95',
        dietary: [],
        category: 'Loaded Fries'
      }
    ],
    sides: [
      {
        name: 'Homemade Coleslaw',
        description: '',
        price: '£3.95',
        dietary: ['v'],
        category: 'Sides'
      },
      {
        name: 'Battered Onion Rings',
        description: '',
        price: '£4.95',
        dietary: ['v'],
        category: 'Sides'
      },
      {
        name: 'Chips',
        description: '',
        price: '£4.95',
        dietary: ['v'],
        category: 'Sides'
      },
      {
        name: 'Chef\'s Own Cajun Sauce',
        description: '',
        price: '£2.95',
        dietary: [],
        category: 'Sides'
      },
      {
        name: 'Peppercorn Sauce',
        description: '',
        price: '£2.95',
        dietary: [],
        category: 'Sides'
      },
      {
        name: 'Curry Sauce',
        description: '',
        price: '£2.95',
        dietary: [],
        category: 'Sides'
      },
      {
        name: 'Garlic Bread',
        description: '',
        price: '£4.95',
        dietary: ['v'],
        category: 'Sides'
      },
      {
        name: 'Cheesy Garlic Bread',
        description: '',
        price: '£5.95',
        dietary: ['v'],
        category: 'Sides'
      }
    ],
    desserts: [
      {
        name: 'Sticky Toffee Pudding',
        description: '',
        price: '£7.95',
        dietary: [],
        category: 'Desserts'
      },
      {
        name: 'Belgian Waffle',
        description: '',
        price: '£7.95',
        dietary: ['v'],
        category: 'Desserts'
      },
      {
        name: 'Deluxe Chocolate Fudge Cake',
        description: '',
        price: '£6.95',
        dietary: ['v'],
        category: 'Desserts'
      },
      {
        name: 'Knickerbocker Glory',
        description: '',
        price: '£5.95',
        dietary: ['v'],
        category: 'Desserts'
      },
      {
        name: 'Tablet Sundae',
        description: '',
        price: '£5.95',
        dietary: ['v'],
        category: 'Desserts'
      },
      {
        name: 'Homemade Cheesecake of The Day',
        description: '',
        price: '£6.95',
        dietary: ['v'],
        category: 'Desserts'
      }
    ],
    smallerMenuStarters: [
      {
        name: 'Soup of The Day',
        description: '',
        price: '£4.95',
        dietary: [],
        category: 'Smaller Menu Starters'
      },
      {
        name: 'Breaded Haggis Wedges',
        description: 'Served with Brown Sauce',
        price: '£5.95',
        dietary: [],
        category: 'Smaller Menu Starters'
      },
      {
        name: 'Egg Harlequin',
        description: '',
        price: '£4.95',
        dietary: ['v'],
        category: 'Smaller Menu Starters'
      },
      {
        name: 'Salt & Pepper Chicken',
        description: 'Honey & Chilli Sauce',
        price: '£5.95',
        dietary: [],
        category: 'Smaller Menu Starters'
      }
    ],
    smallerMenuMains: [
      {
        name: 'Homemade Steak Pie',
        description: 'Signature Creamery Steak Pie. Tender chunks of slow cooked beef. Served with fresh vegetables',
        price: '£12.95',
        dietary: [],
        category: 'Smaller Menu Mains'
      },
      {
        name: 'Haddock & Chips',
        description: 'Breaded or Battered Angel Cut Haddock. Served Peas & Lemon',
        price: '£11.95',
        dietary: [],
        category: 'Smaller Menu Mains'
      },
      {
        name: 'Cheese & Ham Salad',
        description: '',
        price: '£9.95',
        dietary: [],
        category: 'Smaller Menu Mains'
      },
      {
        name: 'Chicken Goujon & Sweet Chilli Mayo Wrap',
        description: '',
        price: '£9.95',
        dietary: [],
        category: 'Smaller Menu Mains'
      },
      {
        name: 'Macaroni Cheese',
        description: 'Macaroni Pasta in our own cheese sauce. Served with Chips and Garlic Bread',
        price: '£8.95',
        dietary: ['v'],
        category: 'Smaller Menu Mains'
      },
      {
        name: 'Omelette',
        description: '',
        price: '£9.95',
        dietary: ['v'],
        category: 'Smaller Menu Mains'
      }
    ],
    smallerMenuDesserts: [
      {
        name: 'Ice cream sundae',
        description: '',
        price: '£4.95',
        dietary: ['v'],
        category: 'Smaller Menu Desserts'
      },
      {
        name: 'Homemade Cheesecake of The Day',
        description: '',
        price: '£6.95',
        dietary: ['v'],
        category: 'Smaller Menu Desserts'
      }
    ],
    kidsStarters: [
      {
        name: 'Soup of The Day',
        description: '',
        price: '',
        dietary: [],
        category: 'Kids Starters'
      },
      {
        name: 'Cheesy Wedges',
        description: '',
        price: '',
        dietary: ['v'],
        category: 'Kids Starters'
      },
      {
        name: 'Garlic Bread',
        description: '',
        price: '',
        dietary: ['v'],
        category: 'Kids Starters'
      }
    ],
    kidsMains: [
      {
        name: 'Fish & Chips',
        description: 'All Kids Mains served with Chips. Choice of peas, salad or beans',
        price: '',
        dietary: [],
        category: 'Kids Mains'
      },
      {
        name: 'Chicken Nuggets',
        description: 'All Kids Mains served with Chips',
        price: '',
        dietary: [],
        category: 'Kids Mains'
      },
      {
        name: 'Sausages',
        description: 'All Kids Mains served with Chips',
        price: '',
        dietary: [],
        category: 'Kids Mains'
      },
      {
        name: 'Homemade Macaroni Cheese',
        description: 'All Kids Mains served with Chips',
        price: '',
        dietary: ['v'],
        category: 'Kids Mains'
      },
      {
        name: 'Homemade Cheeseburger',
        description: 'All Kids Mains served with Chips',
        price: '',
        dietary: [],
        category: 'Kids Mains'
      },
      {
        name: 'Margherita Pizza',
        description: 'All Kids Mains served with Chips',
        price: '',
        dietary: ['v'],
        category: 'Kids Mains'
      },
      {
        name: 'Ham sandwich',
        description: 'Served with Carrot Sticks and Cucumber',
        price: '',
        dietary: [],
        category: 'Kids Mains'
      }
    ],
    kidsDesserts: [
      {
        name: 'Waffle & Ice Cream',
        description: 'Chocolate Sauce. Vanilla Ice Cream. Optional Sauce (Toffee, Strawberry or Chocolate)',
        price: '',
        dietary: ['v'],
        category: 'Kids Desserts'
      }
    ]
  };

  const DietaryIcon: React.FC<{ type: string }> = ({ type }) => {
    const getTooltipData = () => {
      switch (type) {
        case 'v':
          return { label: 'Vegetarian', icon: <Leaf className="w-4 h-4 text-green-500" /> };
        case 'vegan':
          return { label: 'Vegan', icon: <Sprout className="w-4 h-4 text-green-600" /> };
        case 'gf':
          return { label: 'Gluten Free', icon: <Wheat className="w-4 h-4 text-yellow-500" /> };
        case 'vegan-option':
          return { 
            label: 'Vegan Option Available', 
            icon: (
              <div className="relative">
                <Sprout className="w-4 h-4 text-green-400" />
                <span className="absolute -top-1 -right-1 text-[8px] text-green-400">*</span>
              </div>
            )
          };
        case 'gf-option':
          return { 
            label: 'Gluten Free Option Available', 
            icon: (
              <div className="relative">
                <Wheat className="w-4 h-4 text-yellow-400" />
                <span className="absolute -top-1 -right-1 text-[8px] text-yellow-400">*</span>
              </div>
            )
          };
        default:
          return null;
      }
    };

    const tooltipData = getTooltipData();
    if (!tooltipData) return null;

    return (
      <span className="mr-2 inline-flex group relative cursor-help">
        {tooltipData.icon}
        <span className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10 border border-primary-gold">
          {tooltipData.label}
        </span>
      </span>
    );
  };

  const DishCard: React.FC<DishProps> = ({ name, description, price, dietary }) => {
    return (
      <div className="bg-primary-black border border-gray-800 rounded-lg p-6 hover:border-primary-gold transition-colors duration-300">
        <div className="flex justify-between items-start mb-3">
          <h3 className="text-xl font-bold text-white font-display flex-1">{name}</h3>
          <span className="text-primary-gold text-xl font-bold ml-4">{price}</span>
        </div>
        <p className="text-gray-400 text-sm mb-3">{description}</p>
        {dietary.length > 0 && (
          <div className="flex items-center">
            {dietary.map((diet, idx) => (
              <DietaryIcon key={idx} type={diet} />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="pt-20 bg-primary-black min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <SectionHeader
          eyebrow="OUR MENU"
          title="Culinary Delights"
          subtitle="Explore our carefully curated menu featuring fresh, locally sourced ingredients and bold flavours"
          darkMode={true}
        />

        {/* Dietary Key */}
        <div className="bg-primary-black border border-primary-gold rounded-lg p-6 mb-12 max-w-3xl mx-auto">
          <h4 className="text-lg font-bold text-primary-gold mb-4 font-display text-center">Dietary Information</h4>
          <p className="text-gray-400 text-sm mb-4 text-center text-bold">Dietary Requirements - Please inform your server of any dietary requirements or allergies. All our dishes are prepared in a kitchen where allergens are present.</p>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 text-sm text-gray-300">
            <div className="flex items-center">
              <Leaf className="w-4 h-4 text-green-500 mr-2" />
              <span>Vegetarian</span>
            </div>
            <div className="flex items-center">
              <Sprout className="w-4 h-4 text-green-600 mr-2" />
              <span>Vegan</span>
            </div>
            <div className="flex items-center">
              <Wheat className="w-4 h-4 text-yellow-500 mr-2" />
              <span>Gluten Free</span>
            </div>
            <div className="flex items-center">
              <div className="relative mr-2">
                <Sprout className="w-4 h-4 text-green-400" />
                <span className="absolute -top-1 -right-1 text-[8px] text-green-400">*</span>
              </div>
              <span>Vegan Option</span>
            </div>
            <div className="flex items-center">
              <div className="relative mr-2">
                <Wheat className="w-4 h-4 text-yellow-400" />
                <span className="absolute -top-1 -right-1 text-[8px] text-yellow-400">*</span>
              </div>
              <span>GF Option</span>
            </div>
          </div>
        </div>

        {/* Breakfast Menu Accordion */}
        <div className="mb-8 border-2 border-primary-gold rounded-lg bg-gray-900 bg-opacity-50 overflow-hidden">
          <button
            onClick={(e) => {
              e.preventDefault();
              setOpenAccordion(openAccordion === 'breakfast' ? '' : 'breakfast');
            }}
            className="w-full flex items-center justify-between p-6 hover:bg-gray-800 transition-colors"
          >
            <div>
              <h2 className="text-3xl font-bold text-primary-gold font-display">Breakfast Menu</h2>
              <p className="text-gray-300 mt-2">Served 9-11:30am • 7 Days a Week</p>
            </div>
            <ChevronDown className={`w-8 h-8 text-primary-gold transition-transform ${openAccordion === 'breakfast' ? 'rotate-180' : ''}`} />
          </button>
          {openAccordion === 'breakfast' && (
            <div className="p-6 pt-0">
              <div className="mb-8">
                <p className="text-gray-300 mb-6 text-center italic">All breakfast items are prepared fresh to order with locally sourced ingredients</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {menuCategories.breakfast.map((dish, index) => (
                    <DishCard key={index} {...dish} />
                  ))}
                </div>
                <p className="text-gray-300 mt-6 text-center">Add an extra item for £1</p>
              </div>
            </div>
          )}
        </div>

        {/* Main Menu Accordion */}
        <div className="mb-8 border-2 border-primary-gold rounded-lg bg-gray-900 bg-opacity-50 overflow-hidden">
          <button
            onClick={(e) => {
              e.preventDefault();
              setOpenAccordion(openAccordion === 'main' ? '' : 'main');
            }}
            className="w-full flex items-center justify-between p-6 hover:bg-gray-800 transition-colors"
          >
            <h2 className="text-3xl font-bold text-primary-gold font-display">Full Menu</h2>
            <ChevronDown className={`w-8 h-8 text-primary-gold transition-transform ${openAccordion === 'main' ? 'rotate-180' : ''}`} />
          </button>
          {openAccordion === 'main' && (
            <div className="p-6 pt-0">
              {/* Starters */}
              <div className="mb-16">
                <h2 className="text-4xl font-bold text-primary-gold mb-8 font-display">Starters</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {menuCategories.starters.map((dish, index) => (
              <DishCard key={index} {...dish} />
            ))}
          </div>
        </div>

        {/* Mains */}
        <div className="mb-16">
          <h2 className="text-4xl font-bold text-primary-gold mb-8 font-display">Main Courses</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {menuCategories.mains.map((dish, index) => (
              <DishCard key={index} {...dish} />
            ))}
          </div>
        </div>

        {/* Burgers */}
        <div className="mb-16">
          <h2 className="text-4xl font-bold text-primary-gold mb-8 font-display">Burgers</h2>
          <p className="text-gray-300 mb-6 text-center">All burgers have the 4oz or 8oz option</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {menuCategories.burgers.map((dish, index) => (
              <DishCard key={index} {...dish} />
            ))}
          </div>
          <p className="text-gray-300 mt-6 text-center">Choice to add Haggis or Bacon to All Burgers (£2)</p>
        </div>

        {/* Loaded Fries */}
        <div className="mb-16">
          <h2 className="text-4xl font-bold text-primary-gold mb-8 font-display">Loaded Fries</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {menuCategories.loadedFries.map((dish, index) => (
              <DishCard key={index} {...dish} />
            ))}
          </div>
        </div>

        {/* Sides */}
        <div className="mb-16">
          <h2 className="text-4xl font-bold text-primary-gold mb-8 font-display">Sides</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {menuCategories.sides.map((dish, index) => (
              <DishCard key={index} {...dish} />
            ))}
          </div>
        </div>

        {/* Desserts */}
        <div className="mb-16">
          <h2 className="text-4xl font-bold text-primary-gold mb-8 font-display">Desserts</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {menuCategories.desserts.map((dish, index) => (
              <DishCard key={index} {...dish} />
            ))}
          </div>
        </div>

            </div>
          )}
        </div>

        {/* Smaller Menu Accordion */}
        <div className="mb-8 border-2 border-primary-gold rounded-lg bg-gray-900 bg-opacity-50 overflow-hidden">
          <button
            onClick={(e) => {
              e.preventDefault();
              setOpenAccordion(openAccordion === 'smaller' ? '' : 'smaller');
            }}
            className="w-full flex items-center justify-between p-6 hover:bg-gray-800 transition-colors"
          >
            <div>
              <h2 className="text-3xl font-bold text-primary-gold font-display">The Creamery Smaller Menu</h2>
              <p className="text-gray-300 mt-2">2 Courses for £16.95 / 3 Courses for £19.95</p>
            </div>
            <ChevronDown className={`w-8 h-8 text-primary-gold transition-transform ${openAccordion === 'smaller' ? 'rotate-180' : ''}`} />
          </button>
          {openAccordion === 'smaller' && (
            <div className="p-6 pt-0">
              {/* Smaller Menu Starters */}
              <div className="mb-16">
                <h3 className="text-3xl font-bold text-primary-gold mb-6 font-display">Starters</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {menuCategories.smallerMenuStarters.map((dish, index) => (
                    <DishCard key={index} {...dish} />
                  ))}
                </div>
              </div>

              {/* Smaller Menu Mains */}
              <div className="mb-16">
                <h3 className="text-3xl font-bold text-primary-gold mb-6 font-display">Main Courses</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {menuCategories.smallerMenuMains.map((dish, index) => (
                    <DishCard key={index} {...dish} />
                  ))}
                </div>
              </div>

              {/* Smaller Menu Desserts */}
              <div className="mb-16">
                <h3 className="text-3xl font-bold text-primary-gold mb-6 font-display">Desserts</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {menuCategories.smallerMenuDesserts.map((dish, index) => (
                    <DishCard key={index} {...dish} />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Kids Menu Accordion */}
        <div className="mb-8 border-2 border-primary-gold rounded-lg bg-gray-900 bg-opacity-50 overflow-hidden">
          <button
            onClick={(e) => {
              e.preventDefault();
              setOpenAccordion(openAccordion === 'kids' ? '' : 'kids');
            }}
            className="w-full flex items-center justify-between p-6 hover:bg-gray-800 transition-colors"
          >
            <div>
              <h2 className="text-3xl font-bold text-primary-gold font-display">Kids Menu</h2>
              <p className="text-gray-300 mt-2">2 Courses for £8.95</p>
            </div>
            <ChevronDown className={`w-8 h-8 text-primary-gold transition-transform ${openAccordion === 'kids' ? 'rotate-180' : ''}`} />
          </button>
          {openAccordion === 'kids' && (
            <div className="p-6 pt-0">
              {/* Kids Starters */}
              <div className="mb-16">
                <h3 className="text-3xl font-bold text-primary-gold mb-6 font-display">Starters</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {menuCategories.kidsStarters.map((dish, index) => (
                    <DishCard key={index} {...dish} />
                  ))}
                </div>
              </div>

              {/* Kids Mains */}
              <div className="mb-16">
                <h3 className="text-3xl font-bold text-primary-gold mb-6 font-display">Mains</h3>
                <p className="text-gray-300 mb-6">All Kids Mains served with Chips</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {menuCategories.kidsMains.map((dish, index) => (
                    <DishCard key={index} {...dish} />
                  ))}
                </div>
              </div>

              {/* Kids Desserts */}
              <div className="mb-16">
                <h3 className="text-3xl font-bold text-primary-gold mb-6 font-display">Desserts</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {menuCategories.kidsDesserts.map((dish, index) => (
                    <DishCard key={index} {...dish} />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Allergen Notice */}
        <div className="bg-primary-black border border-primary-gold rounded-lg p-6 text-center max-w-7xl mx-auto">
          <p className="text-gray-400 text-sm">
            <strong className="text-primary-gold">Allergen Information:</strong> Please inform your server of any dietary requirements or allergies. 
            All our dishes are prepared in a kitchen where allergens are present.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MenuPage;
